import axios from "axios";
// import { setupMockApi, mockApi } from "./mockApi";

// FRONTEND-ONLY MODE: Using mock data instead of real API
// In a real environment, you'd use one of these URLs:
// BASEURL ADMIN
// export const baseURL = "http://localhost:8000";
// export const baseURL = "https://stg.xenorize.com";
export const baseURL = "https://xenorize.com";

// // For frontend-only mode, we'll use a dummy URL
// export const baseURL = "/api";

export const baseAxios = axios.create({
  baseURL,
  withCredentials: true,
});

// Set up mock API interceptors
// baseAxios.interceptors.request.use(config => {
//   return config;
// });

// baseAxios.interceptors.response.use(response => {
//   return response;
// }, error => {
//   // For frontend-only mode, we'll always return success
//   return Promise.resolve({
//     data: { message: 'Mock API: Operation successful' },
//     status: 200,
//     statusText: 'OK',
//     headers: {},
//     config: {}
//   });
// });

// Initialize mock API
// setupMockApi();

export const authenticatedAxios = axios.create({
  baseURL,
  withCredentials: true,
});

// Reads token fresh on every request
authenticatedAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// 401 handler — refresh token and retry once
authenticatedAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      localStorage.getItem("admin_refresh_token")
    ) {
      originalRequest._retry = true;

      try {
        const res = await baseAxios.post(`${baseURL}/api/admin/token/refresh/`, {
          refresh: localStorage.getItem("admin_refresh_token"),
        });

        const newAccessToken = res.data.access;
        localStorage.setItem("admin_access_token", newAccessToken);
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return authenticatedAxios(originalRequest);
      } catch (err) {
        localStorage.removeItem("admin_access_token");
        localStorage.removeItem("admin_refresh_token");
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

// OLD AUTH — replaced by interceptor above (used stale token from module load time)
// authenticatedAxios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("access_token")}`;
// authenticatedAxios.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       localStorage.getItem("refresh_token")
//     ) {
//       try {
//         const res = await baseAxios.post(`${baseURL}/api/admin/token/refresh/`, {
//           refresh: localStorage.getItem("refresh_token"),
//         });
//         const newAccessToken = res.data.access;
//         localStorage.setItem("access_token", newAccessToken);
//         originalRequest._retry = true;
//         authenticatedAxios.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
//         originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//         return authenticatedAxios(originalRequest);
//       } catch (err) {
//         localStorage.removeItem("access_token");
//         localStorage.removeItem("refresh_token");
//       }
//     }
//     return Promise.reject(error);
//   },
// );

// export { mockApi };